import { SystemSettingValueChanged } from '@/shared/events/system-setting-value-changed';
import store from '@/store';

async function handleSystemSettingValueChanged(data: SystemSettingValueChanged): Promise<void> {
    await store.dispatch(`settings/loadSystemSettingsAsync`);
}

export default handleSystemSettingValueChanged;
